/**
 * Navigation assistant produit — Lot L-UX-1 étape 3.
 */

import { getArchetypeById, shouldSkipScreen2 } from '../config/produitArchetypes.js';

/** @param {import('../config/produitArchetypes.js').ProduitArchetype['screen2Questions']} questions */
export function buildDefaultScreen2Answers(questions = []) {
  const answers = {};
  for (const q of questions) {
    if (q.type === 'boolean') {
      answers[q.id] = q.default ?? false;
    } else if (q.type === 'number') {
      answers[q.id] = q.default ?? q.min ?? 1;
    } else {
      answers[q.id] = q.default ?? q.choices?.[0]?.value ?? '';
    }
  }
  return answers;
}

/**
 * @param {string} archetypeId
 * @returns {2 | 3}
 */
export function getStepAfterArchetypeSelect(archetypeId) {
  return shouldSkipScreen2(archetypeId) ? 3 : 2;
}

/**
 * Libellés étapes formule pour récap écran 3.
 * @param {Record<string, unknown>} answers
 */
export function getFormuleStepPreview(answers) {
  const n = answers?.formuleSteps;
  if (n === '2') return ['Plat', 'Dessert'];
  if (n === '4+') return ['Étape 1', 'Étape 2', 'Étape 3', 'Étape 4+'];
  return ['Entrée', 'Plat', 'Dessert'];
}

export function getArchetypeRecap(archetypeId) {
  const archetype = getArchetypeById(archetypeId);
  if (!archetype) return null;
  return {
    label: archetype.label,
    subtitle: archetype.subtitle,
    pilotExample: archetype.pilotExample,
  };
}
